export default __webpack_public_path__ + "static/gears-c8a6de1cc0321ea061646bc6e7b2ca26.svg";